<template>
  <div id='page' class="page-container">
    <div class="well">
      <div class="level">
        <div class="level-left">
          <h1>Edit Purchase Order #{{ poData.poNumber }} - {{poData.purchasingAgent}}</h1>
        </div>
         <div class="level-right">
           <button class="button is-medium is-primary" @click="printPage">Print</button>
        </div>
      </div>
      <b-loading :is-full-page="isFullPage" :active.sync="isLoading"></b-loading>
      <po-form 
        :formData="poData"
        ref="poForm"
        :editing="1">
      </po-form>
      <div class="level">
        <b-field>
          <h1>Items</h1>
        </b-field>
      </div>
      <po-lines :data=this.lineData :editing="1" @clicked-add-line-item="addLineItem" @clicked-remove-line-item="removeLineItem"></po-lines>
      <div class="button-bar">
        <button class="button is-medium is-primary is-pulled-left" @click="cancel">Cancel</button>
        <button class="button is-medium is-success is-primary is-pulled-right" @click="updateRecord">Update</button>
      </div>
    </div>
  </div>
</template>

<script>
  import { mapState } from 'vuex';
  import { mapMutations } from 'vuex';
  import store from '../../store/store.js';
  import PurchaseOrderForm from './PurchaseOrderForm'
  import PurchaseOrderLines from './PurchaseOrderLines'
  import jsPDF from 'jspdf'
  
  export default {
    name: 'PurchaseOrderEditPage',
    components: {  
      'po-form': PurchaseOrderForm,
      'po-lines': PurchaseOrderLines
      
    },
    props:['id'],
    data () {
      return {
        poData: {},
        lineData: [],
        removedLineData: [],
        isLoading: false,
        isFullPage: false,
        response: null,
        setDate: null
      }
    },
    
    computed:{
      ...mapState([
        'userInfo',
        'departmentValueList',
        'vendorValueList',
        'purchasingAgentValueList',
        'lineItemDescriptionValueList'
      ]),
      searchQuery(){
        var searchQuery = {
            "query": [{
                "poNumber": this.id
            }]
        };
        return searchQuery;
      }
    },
    
    mounted:function(){
      this.loadData();
      this.loadValueLists();
    },
    
    methods:{
      ...mapMutations([
        'updateDepartmentValueList',
        'updateVendorValueList',
        'updatePurchasingAgentValueList',
        'updateLineItemDescriptionValueList'
      ]),
      // Brings up the print dialogue window, can save to pdf from there
      printPage(){
        window.print();
      },
      
      dateFormatted(date){
       return date;
      },           
      loadData(){
        var self = this;
        var poForm = this.$refs.poForm;
        self.isLoading = true;
        this.$http.post('api/v2/find.php?layout=purchaseOrder-dataEntry', this.searchQuery)
        .then( response => {
          if(response.data.messages[0].code === "401"){
            this.$toast.open(response.data.messages[0].message);
            return;
          }
          if(response.data.messages[0].code != 0){
            this.$toast.open(response.data.messages[0].message);
            return;
          }
          response.data.response.data.forEach(function(record){
            var record = response.data.response.data[0];
            self.poData = record.fieldData;
            
            var parts = self.poData.orderDate.split("/");
            var dt = new Date(
                parseInt(parts[2]),
                parseInt(parts[0])-1,
                parseInt(parts[1])
              );
            poForm.setDate(dt);
            
            var portal = record.portalData['PORTAL:PurchaseOrderItems']; 
            portal.forEach(function(row){ 
              self.lineData.push(row);
            })
            self.filteredLineData = self.lineData;
          }); 
          self.isLoading = false;
        })
        .catch( error => {
          if (error.response) {
            this.$toast.open(error.response.status);
          } 
          else {
            this.$toast.open("Unknown Error");
          }
        });
      },
      
      loadValueLists(){
        if((this.departmentValueList.length > 0) && (this.vendorValueList > 0) && (this.purchasingAgentValueList > 0)){
          return;
        }
        var self = this;
        this.$http.get('api/v2/getValueList.php?')
        .then( response => {
          if(response.data.messages[0].code === "401"){
            this.$toast.open(response.data.messages[0].message);
            return;
          }
          if(response.data.messages[0].code != 0){
            this.$toast.open(response.data.messages[0].message);
            return;
          }
          var departmentData = [];
          var vendorData = [];
          var lineItemDescriptionData = [];
          
          var departmentPortal = response.data.response.data[0].portalData['PORTAL:Department'];
          var vendorPortal = response.data.response.data[0].portalData['PORTAL:Vendor'];
          var lineItemDescriptionPortal = response.data.response.data[0].portalData['PORTAL:LineItem']
          
          // Push data to arrays
          departmentPortal.forEach(function(row){ 
            departmentData.push(row);
          });
          vendorPortal.forEach(function(row){ 
            vendorData.push(row);
          });
          lineItemDescriptionPortal.forEach(function(row){
            lineItemDescriptionData.push(row['menu__PURCHASE_ORDER_LINE_ITEM__cart_srt::description']);
          })
          // Save to store
          store.commit('updateDepartmentValueList', departmentData);
          store.commit('updateVendorValueList', vendorData);
          store.commit('updateLineItemDescriptionValueList', lineItemDescriptionData);
        })
        .catch( error => {
          if (error.response) {
            this.$toast.open(error.response.status);
          } 
          else {
            this.$toast.open("Unknown Error");
          }
        });
      },
      
      updateRecord(){
        var compiledData = {
          poData: this.poData,
          lineData: this.lineData,
          removedLineData: this.removedLineData,
          isReceived: null
        }
        var self = this;
        self.isLoading = true;
        var url = 'api/v2/runScript.php?layout=POST&script=POST-UpdateOrCreatePurchaseOrder';
        this.$http.post(url, compiledData)
        .then( response => {
          if(response.data.messages[0].code === "401"){
            this.$toast.open(response.data.messages[0].message);
            self.isLoading = false;
            return;
          }
          if(response.data.messages[0].code  != 0){
            this.$toast.open(response.data.messages[0].message);
            self.isLoading = false;
            return;
          }
          self.isLoading = false;
          this.$toast.open({
                    duration: 5000,
                    message: 'Updated successfully',
                    position: 'is-bottom',
                    type: 'is-success'
          });
          this.$router.push({name: 'DashboardPage'});
        })
        .catch( error => {
          if (error.response) {
            this.$toast.open(error.response.status);
          } 
          else {
            this.$toast.open("Unknown Error");
          }
        }).finally(()=>{
          console.log("Loading Data");
          self.loadData();
        });
        
      },
      // Cancels any changes made to a purchase order and returns to the dashboard
      cancel(){
        this.$router.push({name: 'DashboardPage'})
      },
      // Picks up emit from child and adds a new blank line item 
      addLineItem(obj){
        this.lineData.push(obj);
      },
      // Picks up emit from child and removes the chosen line item
      removeLineItem(lineItem){
        // Add the removed item to the removed item array if not a null item
        var itemToRemove = this.lineData.find(function(i){
          return i.recordId == lineItem.recordId;
        });
        if(itemToRemove['purchase_order__PURCHASE_ORDER_LINE_ITEM__purchaseOrderID::description'] != null &&
           itemToRemove['purchase_order__PURCHASE_ORDER_LINE_ITEM__purchaseOrderID::qty']         != null &&
           itemToRemove['purchase_order__PURCHASE_ORDER_LINE_ITEM__purchaseOrderID::price']       != null &&
           itemToRemove['purchase_order__PURCHASE_ORDER_LINE_ITEM__purchaseOrderID::pricePer']    != null){
          this.removedLineData.push(itemToRemove);
        }
        
        // Remove the item from the line item array
        this.lineData = this.lineData.filter(function(i){
          if(i.recordId != lineItem.recordId) return true;
          else return false;
          });
      }
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .level h1{
    font-family: 'Poppins', sans-serif;
    font-size: 2rem;
    font-weight: 600;
  }
    
  .well{
    margin-left: 30px;
    margin-right: 30px;
    margin-bottom: 15px;
  }

  .is-danger {
    background-color: #d00a0b;
    color: white;
    
  }
  
  .button-bar{
    margin-top: 15px;
  }
</style>




// WEBPACK FOOTER //
// src/pages/PurchaseOrder/PurchaseOrderEditPage.vue